export interface VisitsRepartitionData {
    current: VisitsRepartitionDatas;
    versus: VisitsRepartitionDatas;
    comparison: Pick<VisitsRepartitionDatas, 'nbPerson'>;
}

export interface VisitsRepartitionDatas {
    nbPerson: number;
    averageVisits: number;
    nbVisitsByLevel: Record<string, number>;
}
